/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const ChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Chevron Right 24">
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M7.293 4.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L13.586 12 7.293 5.707a1 1 0 0 1 0-1.414Z"
        className="SVG"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const ChevronRightIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'chevron-right-icon'}
      icon={ChevronRight}
      {...props}
      size={size}
    />
  );
};
